import React from 'react'
import ReactDOM from 'react-dom'

// NOTE!!! Material-UI classes don't work with: import { App }
import App from './app/App'
//import './index.css'

// ===================================
ReactDOM.render(
    <App />,
    document.getElementById('root')
);